var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',[_c('div',{staticClass:"portal-loader"}),_c('div',{staticClass:"portal-loader__icon"},[_c('fa-icon',{attrs:{"icon":['fa', 'couch']}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }